import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const blankToNull = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

export default function Plans() {
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState({ name: "", price: "", billing_cycle: "monthly", max_users: "", max_projects: "", max_clients: "" });
  const load = () => api.get("/admin/plans").then((r) => setPlans(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const create = async () => {
    try {
      await api.post("/admin/plans", {
        name: form.name.trim(),
        price: form.price === "" ? 0 : Number(form.price),
        billing_cycle: form.billing_cycle,
        max_users: blankToNull(form.max_users),
        max_projects: blankToNull(form.max_projects),
        max_clients: blankToNull(form.max_clients),
      });
      setForm({ name: "", price: "", billing_cycle: "monthly", max_users: "", max_projects: "", max_clients: "" });
      load();
      toast.success("Plan created");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };
  const toggle = async (p) => {
    try {
      await api.patch(`/admin/plans/${p.id}`, { active: !p.active });
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };
  const del = async (p) => {
    try {
      await api.delete(`/admin/plans/${p.id}`);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };
  const lim = (v) => (v === null || v === undefined ? "∞" : v);
  return (
    <div className="space-y-5">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-blue-600 font-semibold">Platform</div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900 mt-1">Plans</h1>
      </div>
      <div className="surface-card p-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-2 items-end">
        <div className="col-span-2 sm:col-span-1">
          <label className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">Name</label>
          <Input value={form.name} onChange={(e) => set("name", e.target.value)} />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">Price</label>
          <Input type="number" value={form.price} onChange={(e) => set("price", e.target.value)} />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">Cycle</label>
          <select
            value={form.billing_cycle}
            onChange={(e) => set("billing_cycle", e.target.value)}
            className="w-full border border-border rounded-md px-2 h-9 text-sm bg-white"
          >
            <option value="monthly">monthly</option>
            <option value="annual">annual</option>
          </select>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">Users</label>
          <Input type="number" placeholder="∞" value={form.max_users} onChange={(e) => set("max_users", e.target.value)} />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">Projects</label>
          <Input type="number" placeholder="∞" value={form.max_projects} onChange={(e) => set("max_projects", e.target.value)} />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">Clients</label>
          <Input type="number" placeholder="∞" value={form.max_clients} onChange={(e) => set("max_clients", e.target.value)} />
        </div>
        <Button onClick={create} disabled={!form.name.trim()}>Add plan</Button>
      </div>
      <div className="surface-card overflow-x-auto">
        <table className="w-full text-sm table-tight">
          <thead className="bg-slate-50">
            <tr className="text-left text-[10px] uppercase tracking-[0.1em] text-slate-500">
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Price</th>
              <th className="px-4 py-3">Users</th>
              <th className="px-4 py-3">Projects</th>
              <th className="px-4 py-3">Clients</th>
              <th className="px-4 py-3">Active</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {plans.map((p) => (
              <tr key={p.id} className="border-t border-slate-100">
                <td className="px-4 py-3 font-medium text-slate-800">{p.name}</td>
                <td className="px-4 py-3 tabular-nums">
                  {p.price} <span className="text-xs text-slate-400">/{p.billing_cycle}</span>
                </td>
                <td className="px-4 py-3 tabular-nums">{lim(p.max_users)}</td>
                <td className="px-4 py-3 tabular-nums">{lim(p.max_projects)}</td>
                <td className="px-4 py-3 tabular-nums">{lim(p.max_clients)}</td>
                <td className="px-4 py-3">
                  <button className="text-xs text-slate-500 hover:text-slate-900" onClick={() => toggle(p)}>
                    {p.active ? "Active" : "Inactive"}
                  </button>
                </td>
                <td className="px-4 py-3">
                  <button className="text-xs text-rose-500 hover:text-rose-700" onClick={() => del(p)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {plans.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center text-slate-400 py-10 text-xs">No plans yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
